import { render, staticRenderFns } from "./Transfer_Tac.vue?vue&type=template&id=2547b491&scoped=true&"
import script from "./Transfer_Tac.vue?vue&type=script&lang=js&"
export * from "./Transfer_Tac.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_Tac.vue?vue&type=style&index=0&id=2547b491&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547b491",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
